module.exports = __webpack_public_path__ + "static/media/aleksei_sch.a014d57b.jpg";